class AnimatedNumber {


    constructor(container, className, text, position = {top: -30, left: 0, right: 0})
    {
        let numberBgClass = 'bg-white';
        if($('html').hasClass('darkmode')) 
        {
            numberBgClass = 'bg-gray';
        }

        const htmlClass = `${className} ${numberBgClass} text-color-blue absolute  font-bold text-[16px]`;
        const htmlStyle =  `opacity: 0; top: ${position.top}px; left: ${position.left}px; right: ${position.right}px;`;

        $(`.${className}`).remove();

        container.append(`<span class="${htmlClass}" style="${htmlStyle}">+${text}</span>`);
        
        this.element = $(`.${className}`);
    }

    animate(
        keyframes,
        transformDuration = 2000,
    ) 
    {
        const t = this;

        setTimeout(
            function() {
                t.element
                    .animate(
                        keyframes,
                        transformDuration, 
                        function() { $(this).fadeOut(1000); }
                    );
                }, 
            500
        );

        this.element.animate({opacity: 1}, {duration: 1000});
    }

  
}